import { MutationTree } from "vuex";

import { Role } from "./types";

export const mutations: MutationTree<Role> = {
  SET_ROLE(state, payLoad) {
    state.role = payLoad;
  }
};
